import React, { useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { MemberLocation } from '../../../../api/locations/client';
import {
  CompanyDeviceEditForm,
  EditTeamDeviceFormInterface,
} from '../Forms/CompanyDeviceEditForm';
import TeamDeviceTableRow from './CompanyDeviceTableRaw';
import { CompanyDeviceFormState } from '../Forms/CompanyDeviceForm';

export type CompanyDevice = {
  mac: string;
  type: string;
  name: string;
  location_uuid: string;
  is_owner_inactive: boolean;
  COMPANY_ID: string;
  COMPANY_NAME: string;
};

export type CompanyDevicesTableProps = {
  devices: CompanyDevice[];
  locations: MemberLocation[];
  onUpdate: () => void;
  onMessage: (msg: JSX.Element) => void;
};

export const CompanyDevicesTable: React.FC<CompanyDevicesTableProps> = ({
  devices,
  locations,
  onUpdate,
  onMessage,
}) => {
  const editFormRef = useRef<EditTeamDeviceFormInterface>(null);

  const [callback, setCallback] = useState<Function>();
  const [currentMAC, setCurrentMAC] = useState<string>('');
  const [currentDevice, setCurrentDevice] = useState<CompanyDeviceFormState>();

  return (
    <div className="ray-grid__cell--span-full">
      <CompanyDeviceEditForm
        ref={editFormRef}
        locations={locations}
        currentMAC={currentMAC}
        deviceData={currentDevice}
        title={
          <FormattedMessage
            id="tabs.companyDevices.titles.editFormTitle"
            defaultMessage="Are you sure you want to change ownership for this device?"
          />
        }
        onOK={() => {
          setCurrentMAC('');
          setCurrentDevice(undefined);

          if (callback) {
            callback();
          }
        }}
        onCancel={() => {
          setCurrentMAC('');
          setCurrentDevice(undefined);

          if (callback) {
            callback();
          }
        }}
        onFinished={onUpdate}
        onMessage={onMessage}
      />

      <table className="ray-table">
        <thead>
          <tr>
            <th>
              <FormattedMessage
                id="tabs.device.table.header.columns.0"
                defaultMessage="Name"
              />
            </th>
            <th>
              <FormattedMessage
                id="tabs.device.table.header.columns.1"
                defaultMessage="MAC address"
              />
            </th>
            <th>
              <FormattedMessage
                id="tabs.device.table.header.columns.2"
                defaultMessage="Type"
              />
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {devices.map((device: CompanyDevice) => (
            <TeamDeviceTableRow
              key={device.mac}
              device={device}
              onEdit={(
                mac: string,
                device: CompanyDeviceFormState,
                onCancel?: () => void,
              ) => {
                setCurrentMAC(mac);
                setCurrentDevice(device);
                setCallback(onCancel);

                if (editFormRef.current) {
                  editFormRef.current.show();
                }
              }}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};
